export default __webpack_public_path__ + "static/media/AutomationCondition.6bf97c09.svg";